import {type PartialOptions, type UIChild, UI} from "../../../stem-core/ui/UIBase";
import type {AdminMerchant} from "../../../client/state/merchant/AdminMerchantStore";
import type {Money} from "../../../stem-core/localization/Money";
import {SortableTableInterface} from "../../../stem-core/ui/table/SortableTable.jsx";
import {Table} from "../../../stem-core/ui/table/Table.jsx";
import {StemDate} from "../../../stem-core/time/Date.js";
import {Link} from "../../../stem-core/ui/primitives/Link";
import {LegalEntityModal} from "./legal-entities/LegalEntityModal.jsx";


// TODO: Fix sort icons
// The type argument is erased, so this is still the one factory call; it only names the row
export class MerchantTableList extends SortableTableInterface<AdminMerchant, typeof Table<AdminMerchant>>(Table<AdminMerchant>) {
    getDefaultOptions(options?: this["options"]): PartialOptions<MerchantTableList> {
        const column = (name: string, projection: (merchant: AdminMerchant) => UIChild, rawProjection?: (merchant: AdminMerchant) => string | number) => ({
            value: projection,
            rawValue: rawProjection || projection,
            headerName: name,
            headerStyle: {
                textAlign: "center",
                margin: "auto",
                verticalAlign: "middle",
            },
        });

        const moneyColumn = (name: string, projection: (merchant: AdminMerchant) => Money) => ({
            ...column(name, (merchant) => projection(merchant) || "-"),
            rawValue: (merchant: AdminMerchant) => {
                const value = projection(merchant);
                return value?.getAmount() || 0;
            },
            cellStyle: {
                textAlign: "right",
                width: "10%",
                verticalAlign: "middle",
                fontWeight: "bold",
            }
        });

        return {
            ...super.getDefaultOptions(options),
            columns: [
                column("Name",
                        merchant => <Link href={`/merchants/${merchant.id}`}>
                            {merchant.name ?? "??"}
                    </Link>,
                        merchant => (merchant.name ?? "??")),
                column("Legal entity", merchant => {
                    if (!merchant.legalEntity) {
                        return "??"
                    }

                    //TODO: add modal here
                    return <div onClick={() => LegalEntityModal.show({legalEntity: merchant.legalEntity})}
                                style={{cursor: "pointer"}}>
                        {merchant.legalEntity.name}
                    </div>
                }),
                column("Date added", merchant => StemDate.format(merchant.createdAt, "YYYY/MM/DD")),
                moneyColumn("All time revenue", merchant => merchant.getRevenue()?.allTimeRevenue),
                moneyColumn("Last 30d revenue", merchant => merchant.getRevenue()?.last30dRevenue),
                moneyColumn("Last 24h revenue", merchant => merchant.getRevenue()?.last24hRevenue),
                // TODO: Add this later
                // moneyColumn("Monthly recurring", merchant => merchant.monthlyRecurring ?? 0),
                moneyColumn("Outstanding balance", merchant => merchant.getRevenue()?.outstandingBalance),
            ],
        };
    }
}
